// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.typing-container {
    display: flex;
    gap: 8px;
    justify-content: flex-start;
    align-items: flex-end;
    animation: fade-in 0.25s ease-out;
}

.typing-avatar {
    width: 28px;
    height: 28px;
    background: rgba(59, 130, 246, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.typing-avatar svg {
    width: 14px;
    height: 14px;
    color: #3B82F6;
}

.typing-bubble {
    background: #f3f4f6;
    color: #1f2937;
    padding: 10px 14px;
    border-radius: 16px;
    border-bottom-left-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.typing-content {
    display: flex;
    align-items: center;
    gap: 8px;
}

.typing-dots {
    display: flex;
    gap: 4px;
    align-items: center;
}

.typing-dot {
    width: 7px;
    height: 7px;
    background: rgba(59, 130, 246, 0.55);
    border-radius: 50%;
    animation: typing-bounce 1.4s infinite ease-in-out;
}

.typing-text {
    font-size: 12px;
    color: #9ca3af;
}

@keyframes typing-bounce {
    0%, 60%, 100% {
        transform: translateY(0);
    }
    30% {
        transform: translateY(-6px);
    }
}

@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(6px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TypingIndicator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":[".typing-container {\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: flex-start;\r\n    align-items: flex-end;\r\n    animation: fade-in 0.25s ease-out;\r\n}\r\n\r\n.typing-avatar {\r\n    width: 28px;\r\n    height: 28px;\r\n    background: rgba(59, 130, 246, 0.1);\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.typing-avatar svg {\r\n    width: 14px;\r\n    height: 14px;\r\n    color: #3B82F6;\r\n}\r\n\r\n.typing-bubble {\r\n    background: #f3f4f6;\r\n    color: #1f2937;\r\n    padding: 10px 14px;\r\n    border-radius: 16px;\r\n    border-bottom-left-radius: 4px;\r\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.typing-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.typing-dots {\r\n    display: flex;\r\n    gap: 4px;\r\n    align-items: center;\r\n}\r\n\r\n.typing-dot {\r\n    width: 7px;\r\n    height: 7px;\r\n    background: rgba(59, 130, 246, 0.55);\r\n    border-radius: 50%;\r\n    animation: typing-bounce 1.4s infinite ease-in-out;\r\n}\r\n\r\n.typing-text {\r\n    font-size: 12px;\r\n    color: #9ca3af;\r\n}\r\n\r\n@keyframes typing-bounce {\r\n    0%, 60%, 100% {\r\n        transform: translateY(0);\r\n    }\r\n    30% {\r\n        transform: translateY(-6px);\r\n    }\r\n}\r\n\r\n@keyframes fade-in {\r\n    from {\r\n        opacity: 0;\r\n        transform: translateY(6px);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translateY(0);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
